/// <amd-module name="Wit/SprintsHub/SprintsView/Utils/RoutingUtils" />
import { getTFSProject } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

const backlogRoute = "ms.vss-work-web.new-backlogs-content-route";
const formRoute = "ms.vss-work-web.new-work-item-form-route";

export function getBacklogUrl(pageContext: IVssPageContext, projectId: string, teamName: string, backlogLevel?: string, rightPane?: string) {
    let routeValues = {
        pivot: "backlog",
        project: projectId,
        teamName,
        ...(backlogLevel && { backlogLevel: backlogLevel }),
        ...(rightPane && { rightPane: rightPane })
    };

    return routeUrl(pageContext, backlogRoute, routeValues);
}

export function getWorkItemUrl(pageContext: IVssPageContext, workItemId: number) {
    const projectName = getTFSProject(pageContext)?.name;
    const routeValues = {
        project: projectName || "",
        id: "" + workItemId
    };

    return routeUrl(pageContext, formRoute, routeValues);
}
